const title = {
  type: 'Label',
  name: '7',
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: '400',
  letterSpacing: '1.8px'
}

const name = {
  type: 'Paragraph',
  name: '1',
  fontSize: '32px',
  lineHeight: '40px',
  fontWeight: '400',
}

const bio = {
  type: 'Paragraph',
  name: '3',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '400',
}

const contact = {
  type: 'Paragraph',
  name: '6',
  fontSize: '14px',
  lineHeight: '17.5px',
  fontWeight: '700',
}

const loyaltyPersonalShopper = {
  title,
  name,
  bio,
  contact
}

export default loyaltyPersonalShopper